import type { AppDispatch } from "../../../../store/store";
import { getSchemaOrderAsync } from "../../../../store/reducers/orderSlice";

// // api/workflow.api.ts
// export const fetchWorkflowByProvider = async (
//       provider: string,
//       dispatch: AppDispatch,
// ) =>
// {
//       try
//       {
//             // @ts-ignore
//             const action = await dispatch(
//                   // @ts-ignore
//                   getSchemaOrderAsync({
//                         type: "order_tasking",
//                         provider_id: provider,
//                   }),
//             ).unwrap();

//             debugger

//             const payload = action.payload;

//             // The thunk returns axios response on success (payload.data contains workflow)
//             // or an error object on failure (payload.message exists)
//             if (payload.message)
//             {
//                   // Propagate error object
//                   return { message: payload.message };
//             }

//             // Return the actual workflow data from axios response
//             return payload.data;
//       } catch (error)
//       {
//             return null;
//       }
// };

export const fetchWorkflowByProvider = async (
   provider: string,
   dispatch: AppDispatch,
) =>
{
   try
   {
      const data = await dispatch(
         // @ts-ignore
         getSchemaOrderAsync({
            type: "order_tasking",
            provider_id: provider,
         }),
      ).unwrap();


      return {
         data: data?.data?.data,
         error: data ? null : "Can not fetch schema order",
      };
   } catch (error: any)
   {

      return {
         data: null,
         error: error?.message || "Can not fetch schema order",
      };
   }
};

export const fetchStepSchema = async (url: string) =>
{
   const res = await fetch(url);
   return res.json();
};
